module.exports = __webpack_public_path__ + "img/code.5f16e5d2.png";